import { useI18n } from "vue-i18n";

import { useMutation } from "@tanstack/vue-query";

import { useNotification } from "@/hooks/notifications";
import optionsApiService from "@/services/modules/options";

import type { KeyboardShortcutPayload } from "@/models/options";

export const useUpdateKeyboardShortcutMutation = () => {
  const { showMessage } = useNotification();
  const { t } = useI18n();
  return useMutation({
    mutationFn: (payload: KeyboardShortcutPayload) =>
      optionsApiService.updateKeyboardShortcuts(payload),
    onError: () => {
      showMessage(t("COMMON.ERROR_OCCURRED"), "error");
    },
  });
};
